export const PIXEL_RATIO = window.devicePixelRatio || 1;
export const VIEWPORT_RATIO = 0.98;



// WEBPACK FOOTER //
// ./src/utils/constants.js